import {
  headerButtonClassName,
  headerStackedToolClassName,
  headerToolClassName,
} from "@/components/layout/headerButtonClassName";
import { Button } from "@/components/ui/button";
import { useFlashcardsStore } from "@/stores/flashcardsStore";
import { NavCardsIcon } from "@/components/flashcards/Icons";

interface Props {
  enrollmentId: string;
}

export const FlashcardsHeaderButton = ({ enrollmentId }: Props) => {
  const { view, open, loadDecks } = useFlashcardsStore();
  const isActive = view !== null;

  const handleClick = () => {
    open();
    void loadDecks(enrollmentId);
  };

  return (
    <Button
      variant="outline"
      size="sm"
      className={[
        "border-transparent text-primary-foreground",
        headerButtonClassName,
        headerStackedToolClassName,
        headerToolClassName(isActive),
      ].join(" ")}
      onClick={handleClick}
    >
      <NavCardsIcon size={16} />
      Lernkarten
    </Button>
  );
};
